// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"177":"home","497":"single"}[chunkId] + "." + {"177":"0f8bdd67","497":"75b28590"}[chunkId] + ".css";
};